var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGenderNonbinary = function SvgIconGenderNonbinary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.178 1.024a1 1 0 1 0-1.05 1.702l1.966 1.212-1.965 1.21a1 1 0 1 0 1.049 1.703L11 5.73v2.338a7.377 7.377 0 0 0 1 14.683 7.375 7.375 0 0 0 1-14.683V5.728l1.822 1.123a1 1 0 0 0 1.05-1.702l-1.966-1.211 1.966-1.212a1 1 0 0 0-1.05-1.702L12 2.763zM12 10a5.375 5.375 0 1 0 0 10.75A5.375 5.375 0 0 0 12 10",
    clipRule: "evenodd"
  })));
};
export default SvgIconGenderNonbinary;